import {
    useLocation,
    useNavigate,
} from 'react-router-dom'
import {
    useCallback,
} from 'react'
import {
    useQueryClient,
} from '@tanstack/react-query'
import {
    ActionBulkComponentFunction,
    ActionComponentFunction,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

import CloseButton from '../CloseButton'
import useStyles from './ActionWrapper.styles'

type Props = {
    component: ActionComponentFunction | ActionBulkComponentFunction,
    uniqField?: string,
    requestKey?: RequestKeys,
}

const ActionWrapper = ({
    component: Component,
    uniqField = 'id',
    requestKey,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()
    const {
        pathname,
    } = useLocation()
    const navigate = useNavigate()
    const queryClient = useQueryClient()

    const handleGoBack = useCallback(() => {
        /* calculate path like this because
      the action form is rendered alongside the tabs, not as a child
      — so useResolvedPath('..') won’t work. */
        navigate(pathname.split('/').slice(0, -1).join('/'))
    }, [
        navigate,
        pathname,
    ])

    const handleSuccessRedirect = useCallback((data: Partial<{ id: number }>) => {
        if (requestKey) {
            queryClient.invalidateQueries({
                queryKey: [requestKey],
            })
        }
        if (data?.[uniqField]) {
            navigate(`../${CommonRoutes.All}/${CommonRoutes.Edit}/${data?.[uniqField]}`)
        } else {
            navigate('..', {
                relative: 'path',
            })
        }
    }, [
        navigate,
        uniqField,
        requestKey,
        queryClient,
    ])

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <CloseButton onClose={handleGoBack} />
            </div>
            <div className={classes.formContainer}>
                <Component
                    onSuccess={handleSuccessRedirect}
                    onClose={handleGoBack}
                />
            </div>
        </div>
    )
}

export default ActionWrapper
